import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { ButtonTextEnum } from '@app/shared/models/button-text.model';

import { Error, ErrorWithContext } from '../errors.model';

@Component({
  selector: 'app-error',
  templateUrl: './errors.component.html',
  styleUrls: ['./errors.component.scss'],
  standalone: false
})
export class ErrorsComponent implements OnInit {
  buttonTextEnum = ButtonTextEnum;

  routeParams: ErrorWithContext;
  data: Error;

  constructor(private activatedRoute: ActivatedRoute) {}

  ngOnInit() {
    this.routeParams = this.activatedRoute.snapshot
      .queryParams as ErrorWithContext;
    this.data = this.activatedRoute.snapshot.data as Error;
  }
}
